export const INFORMATION_TYPES = {
  error: {
    cssClass: 'error',
    icon: 'times'
  },
  warning: {
    cssClass: 'warning',
    icon: 'exclamation-triangle'
  },
  success: {
    cssClass: 'success', icon: 'check'
  },
  info: {
    cssClass: 'info',
    icon: 'info-circle'
  }
};
